import Vue from 'vue'
import App from './App.vue'
// import ElementUI from 'element-ui';

import {
  Dialog,
  Input,
  InputNumber,
  Checkbox,
  Select,
  Option,
  Button,
  Form,
  FormItem,
  Alert,
  Icon,
  Upload,
  Link,
  MessageBox,
  Message,
  Notification
} from 'element-ui';

Vue.use(Dialog);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Alert);
Vue.use(Icon);
Vue.use(Upload);
Vue.use(Link);


Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;


Vue.config.productionTip = false;

// Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')
